module.exports = __webpack_public_path__ + "media/images/badges/material-science-100-d3c403c1952da360d7cb8c7baa79be40.svg";